import useSWRMutation from "swr/mutation";
import { API_REST_METHODS } from "../../../common/constants";
import { fetcher } from "../../../common/hooks";
import { AnnouncementPayload } from "../models";

export const useCreateAnnouncement = ({
    onSuccess,
    onError,
}: {
    onSuccess?: () => void;
    onError?: (err: unknown, key: string) => void;
}) => {
    const {
        trigger: triggerCreateAnnouncement,
        isMutating: isLoadingCreateAnnouncement,
    } = useSWRMutation(
        "/api/notification-management/v1/announcements",
        (
            url: string,
            {
                arg,
            }: {
                arg: { body: AnnouncementPayload };
            }
        ) =>
            fetcher(url, {
                options: {
                    method: API_REST_METHODS.POST,
                    body: JSON.stringify(arg.body),
                },
            }),
        {
            onSuccess,
            onError,
        }
    );

    return {
        triggerCreateAnnouncement,
        isLoadingCreateAnnouncement,
    };
};
